/**
 * @author Di Wang on 25/11/19.
 */
export class ApiAuth {
  public static loginWithGoogle() {
    return '/auth/google-login';
  }
}
